import React, { useState } from "react";
import Header from "components/Atoms/SharedComponents/Details/header";
import {
  Button,
  Stack,
  FormControl,
  InputLabel,
  Select,
  Menu,
  MenuItem,
  IconButton,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import OrderDetailsHead from "components/Organisms/orders/orderDetailsHead";
import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import AssignToEmpolyee from "components/Organisms/orders/Models/assignToEmpolyee";
import AssignToFreelancer from "components/Organisms/orders/Models/assignToFreelancer";
import RouteDriverDetails from "components/Organisms/orders/routesDriverDetails";
// import OrderDetailsHead from "components/Organisms/orders/orderDetails/orderDetailsHead";
// import DriverInfoCard from "components/Organisms/orders/orderDetails/driverInfoCard";
import OrderStatus from "components/Organisms/orders/orderStatus";

// import Breadcrumb from "components/Atoms/SharedComponents/Breadcrumbs/Breadcrumb";
import OrderSummary from "components/Organisms/orders/OrderSummary";
import CustomerInfo from "components/Organisms/orders/customerInfo";
import PaymentDetails from "components/Organisms/orders/paymentDetails";
import OrderRoutes from "components/Organisms/orders/orderRoutes";
import { useThemePalette } from "common/hooks/theme_palette";
import ConfirmationModal from "components/Molecules/Models/ConfirmationModal";
import {
  Canceled,
  Delivered,
  StoreUser,
} from "services/modules/utils/constant";
import { useNavigate } from "react-router-dom";
import { getEmployeesRequest } from "services/modules/orders";
import RoutesCard from "components/Organisms/orders/routesCard";
import OrderNotes from "components/Organisms/orders/OrderNotes";
import MoreVert from "@mui/icons-material/MoreVert";
import VoucherInfo from "components/Organisms/orders/voucherInfo";
import OrderPackagingInfo from "components/Organisms/orders/OrderPackagingInfo";

const OrderDetailsTemplate = ({
  id,
  details,
  breadcrumbs,
  routes,
  employees,
  setFilterObj,
  routeType,
  setSelectedEmployee,
  selectedEmployee,
  handleAssignEmployee,
  handleCloseModel,
  filterObj,
  handleUnAssignDriver,
  setOrderReadyForDelivery,
  orderStatus,
  routeOne,
  routeTwo,
  isRouteOne,
  handleUpdateComplains,
  setUpdateComplaintData,
  updateComplaintData,
  openResplveModal,
  setOpenResplveModal,
  sendRangesRequest,
  load,
  handleAssignFreelancer,
  handleOrderCancel,
  openCancelOrderModal,
  setOpenCancelOrderModal,
  userType,
  routesStatusChanges,
  setOpenUnAssignModal,
  openUnAssignModal,
  handleOrderDelivered,
  handleUpdateOrderStatus,
}) => {
  const { t } = useTranslation();
  const { orangeTwo } = useThemePalette();
  const navigate = useNavigate();
  const [selectedStatus, setSelectedStatus] = useState(orderStatus || "");
  const accountType = localStorage.getItem("account_type");
  const isStore = userType == StoreUser || accountType?.toLowerCase() == "employee";
  React.useEffect(() => {
    setSelectedStatus(orderStatus || "");
  }, [orderStatus]);

  // Anchor for actions popover (3-dots menu)
  const [actionsAnchor, setActionsAnchor] = useState(null);
  const openActions = (e) => setActionsAnchor(e.currentTarget);
  const closeActions = () => setActionsAnchor(null);

  const driverData = [
    {
      title: t("orders.label_route_1_driver_details"),
      driver: routeOne?.driver,
      route: routeOne,
    },
  ];

  const driversData = [
    ...driverData,
    {
      title: t("orders.label_route_2_driver_details"),
      driver: routeTwo?.driver,
      route: routeTwo,
    },
  ];

  const orderSummaryColumns = [
    { accessor: "id", Header: t("products.col_id") },
    { accessor: "product", Header: t("orders.label_product_name") },
    { accessor: "sku", Header: t("orders.label_sku"), sort: true },
    { accessor: "price", Header: t("orders.label_price"), sort: true },
    { accessor: "quantity", Header: t("orders.label_quantity"), sort: true },
    {
      accessor: "total_price",
      Header: t("orders.label_total_price"),
      sort: true,
    },
  ];

  // Title definition
  const orderSummaryTitle = t("orders.label_order_summary");
  const adminPossibleStatus = {
    processing: {
      status: t("orders.status_processing"),
      step: 1,
      next: t("orders.status_assigned"),
    },
    start_route_assigned: {
      status: t("orders.status_assigned"),
      step: 2,
      next: t("orders.status_started"),
    },
    started: {
      status: t("orders.status_started"),
      step: 3,
      next: t("orders.status_assigned"),
    },
    collected: {
      status: t("orders.status_collected_full"),
      step: 4,
      next: t("orders.status_assigned"),
    },
    ready_for_delivery: {
      status: t("orders.status_ready_for_delivery"),
      step: 5,
      next: t("orders.status_assigned"),
    },
    finish_route_assigned: {
      status: t("orders.status_assigned_route_2"),
      step: 6,
      next: t("orders.status_assigned"),
    },
    enroute: { status: t("orders.status_enroute_full"), step: 7 },
    delivered: { status: t("orders.status_delivered"), step: 8, next: null },
  };
  return (
    <Stack gap="24px">
      <Header
        title={`${t("orders.breadcrumb_order_details")}  ( #${id} )`}
        deleteBtn={false}
        editBtn={false}
      >
        {!isStore && (
          <Stack direction="row" alignItems="center" gap={1.5} width={{ xs: "100%", sm: "auto" }}>
            <FormControl size="small" sx={{ flex: 1, minWidth: { xs: 150, sm: 220 } }}>
              <InputLabel id="order-status-label">
                {t("vendors.status")}
              </InputLabel>
              <Select
                labelId="order-status-label"
                id="order-status-select"
                label={t("vendors.status")}
                value={selectedStatus}
                onChange={(e) => {
                  const value = e.target.value;
                  setSelectedStatus(value);
                  handleUpdateOrderStatus && handleUpdateOrderStatus(value);
                }}
              >
                {Object.keys(adminPossibleStatus).map((key) => (
                  <MenuItem key={key} value={key}>
                    {adminPossibleStatus[key].status}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <IconButton aria-label="order-actions" onClick={openActions}>
              <MoreVert />
            </IconButton>
            <Menu
              anchorEl={actionsAnchor}
              open={Boolean(actionsAnchor)}
              onClose={closeActions}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              {orderStatus !== "delivered" && !isStore && (
                <MenuItem
                  disabled={load?.loading && load?.type === "markDelivered"}
                  onClick={() => {
                    handleOrderDelivered();
                    closeActions();
                  }}
                >
                  {t("orders.action_mark_as_delivered")}
                </MenuItem>
              )}

              {orderStatus != "canceled" &&
                !isStore && (
                  <MenuItem
                    onClick={() => {
                      setOpenCancelOrderModal(true);
                      closeActions();
                    }}
                    sx={{ color: "red" }}
                  >
                    {t("orders.action_cancel_order")}
                  </MenuItem>
                )}

              {orderStatus == "collected" && !isStore && (
                <MenuItem
                  disabled={load?.loading && load?.type == "readyForDelivery"}
                  onClick={() => {
                    setOrderReadyForDelivery();
                    closeActions();
                  }}
                >
                  {t("orders.status_ready_for_delivery")}
                </MenuItem>
              )}

              {orderStatus != Canceled &&
                orderStatus == Delivered &&
                !isStore && (
                  <MenuItem
                    onClick={() => {
                      navigate(`/return-request?id=${id}`);
                      closeActions();
                    }}
                  >
                    {t("orders.action_return_request")}
                  </MenuItem>
                )}
            </Menu>
          </Stack>
        )}
      </Header>
      <OrderDetailsHead
        orderPlaceIn={details?.created_at}
        deliveryIn={details?.delivery_date}
        deliveryTime={details?.delivery_time}
        wrapper={details?.cart?.wrapper}
      />
      <Stack
        direction={{ xs: "column", md: "row" }}
        justifyContent="space-between"
        alignItems="stretch"
        gap="24px"
      >
        <Stack width={{ xs: "100%", md: "50%" }}>
          <OrderStatus
            details={details}
            userType={userType}
            routesStatusChanges={routesStatusChanges}
            adminPossibleStatus={adminPossibleStatus}
            title={t("orders.label_order_status")}
            orderStatus={orderStatus}
            height={"100% !important"}
          />
        </Stack>
        {orderStatus == "delivered" ||
        (orderStatus == "canceled" && routeOne?.driver && routeTwo?.driver) ? (
          <RouteDriverDetails
            routeTwo={routeTwo}
            routeOne={routeOne}
            updateComplaintData={updateComplaintData}
            setUpdateComplaintData={setUpdateComplaintData}
            handleUpdateComplains={handleUpdateComplains}
            openResplveModal={openResplveModal}
            setOpenResplveModal={setOpenResplveModal}
            load={load}
            description="View Routes drivers details"
            driver={true}
            driversData={driversData}
          />
        ) : orderStatus == "canceled" &&
          routeOne?.driver &&
          !routeTwo?.driver ? (
          <RouteDriverDetails
            routeOne={routeOne}
            updateComplaintData={updateComplaintData}
            setUpdateComplaintData={setUpdateComplaintData}
            handleUpdateComplains={handleUpdateComplains}
            openResplveModal={openResplveModal}
            setOpenResplveModal={setOpenResplveModal}
            load={load}
            description="View Routes drivers details"
            driver={true}
            driversData={driverData}
          />
        ) : orderStatus == "canceled" &&
          !routeOne?.driver &&
          !routeTwo?.driver ? (
          <RouteDriverDetails
            routeOne={routeOne}
            updateComplaintData={updateComplaintData}
            setUpdateComplaintData={setUpdateComplaintData}
            handleUpdateComplains={handleUpdateComplains}
            openResplveModal={openResplveModal}
            setOpenResplveModal={setOpenResplveModal}
            load={load}
            description={t("orders.label_no_driver_assigned")}
            driver={false}
          />
        ) : isRouteOne(orderStatus) ? (
          <RoutesCard
            data={routeOne}
            handleUnAssignDriver={handleUnAssignDriver}
            handleUpdateComplains={handleUpdateComplains}
            setUpdateComplaintData={setUpdateComplaintData}
            updateComplaintData={updateComplaintData}
            openResplveModal={openResplveModal}
            setOpenResplveModal={setOpenResplveModal}
            load={load}
            userType={userType}
            routeNumber={1}
            routeType={"start_route"}
            openUnAssignModal={openUnAssignModal}
            setOpenUnAssignModal={setOpenUnAssignModal}
          />
        ) : (
          <RoutesCard
            data={routeTwo}
            routeOne={routeOne}
            handleUnAssignDriver={handleUnAssignDriver}
            handleUpdateComplains={handleUpdateComplains}
            setUpdateComplaintData={setUpdateComplaintData}
            updateComplaintData={updateComplaintData}
            openResplveModal={openResplveModal}
            setOpenResplveModal={setOpenResplveModal}
            load={load}
            userType={userType}
            routeTitle={"Route 2"}
            routeType={"finish_route"}
            routeNumber={2}
            driversData={driverData}
            openUnAssignModal={openUnAssignModal}
            setOpenUnAssignModal={setOpenUnAssignModal}
          />
        )}
      </Stack>

      {!isStore && (
        <>
          <AssignToEmpolyee
            setFilterObj={setFilterObj}
            employees={employees}
            routeType={routeType}
            routes={routes}
            setSelectedEmployee={setSelectedEmployee}
            selectedEmployee={selectedEmployee}
            handleAssignEmployee={handleAssignEmployee}
            handleCloseModel={handleCloseModel}
            filterObj={filterObj}
            handleUnAssignDriver={handleUnAssignDriver}
            getEmployeesRequest={getEmployeesRequest}
            id={id}
            load={load}
          />
          <AssignToFreelancer
            employees={employees}
            routeType={routeType}
            routes={routes}
            setSelectedEmployee={setSelectedEmployee}
            selectedEmployee={selectedEmployee}
            handleAssignFreelancer={handleAssignFreelancer}
            handleCloseModel={handleCloseModel}
            sendRangesRequest={sendRangesRequest}
            load={load}
            isRouteOne={isRouteOne}
          />
          <ConfirmationModal
            open={openCancelOrderModal}
            setOpen={setOpenCancelOrderModal}
            text={[t("orders.confirmation_cancel_order_text")]}
            confirmBtnTitle={t("vendors.yes")}
            handleConfirmation={handleOrderCancel}
            load={load?.loading && load?.type == "cancel"}
          />
        </>
      )}
      <Stack gap={4}>
        {!isStore && (
          <>
            <Stack>
              <OrderRoutes details={details} />
            </Stack>
            <Stack direction={{ xs: "column", md: "row" }} gap="24px" justifyContent="space-between">
              <CustomerInfo details={details} />
              <PaymentDetails details={details} />
            </Stack>
            <VoucherInfo details={details} />
          </>
        )}
        {details?.packaging?.length > 0 && (
          <OrderPackagingInfo
            packaging={details.packaging}
            cartItems={details?.cart?.cart_items}
          />
        )}
        <Stack>
          <OrderSummary
            details={details}
            title={orderSummaryTitle}
            columns={orderSummaryColumns}
            products={details?.cart?.cart_items}
            wrapper={details?.cart?.wrapper}
            giftCard={details?.cart?.gift_card}
            currency={details?.cart?.currency?.name}
          />
        </Stack>
        {details?.cart?.special_instructions && (
          <Stack>
            <OrderNotes note={details?.cart?.special_instructions} />
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default OrderDetailsTemplate;
